// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Upload_wrapper__J3HEr","dropzoneWrapper":"Upload_dropzoneWrapper__354dL","dropzoneText":"Upload_dropzoneText__1_ZgY"};